// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane } from 'pixi.js';

const raw = {
  list: [
    {
      id: '3e5fa791-98f4-424f-8440-2666d8437723',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'fe5ccef0-0c84-4c30-9f9a-041191af5d2e',
      type: 'NineSlicePlane',
      name: 'bubble',
      className: '',
      x: -58,
      y: -135,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 125,
      height: 135,
      leftWidth: 80,
      topHeight: 0,
      rightWidth: 39,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Speech_Bubble',
      parent: '3e5fa791-98f4-424f-8440-2666d8437723'
    },
    {
      id: 'de5771b1-5eea-483b-96de-8ac23760bfff',
      type: 'Container',
      name: 'initSlot',
      className: '',
      x: 0,
      y: -78,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3e5fa791-98f4-424f-8440-2666d8437723',
      data: {
        xIncreaseForNextSlot: 100
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class WinStreakChestBubbleLayout {
  static raw = raw;
  root!: Container;
  bubble!: NineSlicePlane;
  initSlot!: Container & { data: typeof raw['list'][2]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
